import React from 'react';
import { Typography, useMediaQuery, useTheme as useMuiTheme } from '@mui/material';

const Logo = ({ ...props }) => {
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  return (
    <Typography
      variant="h5"
      component="span"
      sx={{
        fontFamily: 'Fraunces, serif',
        // Medium, not bold: the serif's detail reads better next to the
        // sans-serif page titles than a heavy block does
        fontWeight: 500,
        fontSize: isMobile ? '1.5rem' : '1.75rem',
        color: 'text.primary', // Uses theme text color automatically
        backgroundColor: 'transparent', // Transparent background to match header
        lineHeight: 1,
        letterSpacing: '0.02em',
        textDecoration: 'none',
        userSelect: 'none',
      }}
      {...props}
    >
      Tuneswell
    </Typography>
  );
};

export default Logo;

